import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import ReminderTimeConfig from './ReminderTimeConfig';
import { createDefaultReminderTime } from './reminderCampaignDefaults';

const ReminderTimeList = ({
  reminderTimes,
  onReminderTimesChange,
  templates,
  communicationEndpoints,
  channel,
  timezones,
  useRelativeSchedule,
}) => {

  const handleAddReminderTime = () => {
    const newReminderTime = createDefaultReminderTime(channel, useRelativeSchedule);
    onReminderTimesChange([...reminderTimes, newReminderTime]);
  };

  const handleDeleteReminderTime = (index) => {
    const newReminderTimes = reminderTimes.filter((_, i) => i !== index);
    onReminderTimesChange(newReminderTimes);
  };

  const handleReminderTimeChange = (index, updatedReminderTime) => {
    const newReminderTimes = [...reminderTimes];
    newReminderTimes[index] = updatedReminderTime;
    onReminderTimesChange(newReminderTimes);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Reminder Times</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddReminderTime}
        >
          Add Reminder Time
        </Button>
      </Box>

      {reminderTimes.map((reminderTime, index) => (
        <ReminderTimeConfig
          key={index}
          index={index}
          reminderTime={reminderTime}
          onReminderTimeChange={(updated) => handleReminderTimeChange(index, updated)}
          onDelete={() => handleDeleteReminderTime(index)}
          templates={templates}
          communicationEndpoints={communicationEndpoints}
          channel={channel}
          timezones={timezones}
          useRelativeSchedule={useRelativeSchedule}
        />
      ))}
    </Box>
  );
};

ReminderTimeList.propTypes = {
  reminderTimes: PropTypes.arrayOf(
    PropTypes.shape({
      days_before: PropTypes.number,
      time: PropTypes.string,
      days_before_relative: PropTypes.number,
      hours_before: PropTypes.number,
      minutes_before: PropTypes.number,
      messages: PropTypes.arrayOf(
        PropTypes.shape({
          template: PropTypes.string,
          content: PropTypes.string,
          email_config: PropTypes.object,
          sms_config: PropTypes.object,
          voice_config: PropTypes.object,
          chat_config: PropTypes.object,
        })
      ),
    })
  ).isRequired,
  onReminderTimesChange: PropTypes.func.isRequired,
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  communicationEndpoints: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  channel: PropTypes.oneOf(['email', 'sms', 'voice', 'chat']).isRequired,
  timezones: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  useRelativeSchedule: PropTypes.bool.isRequired,
};

export default ReminderTimeList; 